import React, { useState, useEffect } from 'react';
import arrowImg from './../assets/images/arrow2.svg'
import { offerTimer } from '../config/constants';
// User sets the future date here (yyyy-mm-ddThh:mm:ss format is best)
const futureDate = offerTimer; 

const OfferTimer = () => {
    // Calculate time left from now to futureDate
    const calculateTimeLeft = () => {
        const difference = new Date(futureDate) - new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            // If expired, show all zeroes
            timeLeft = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    // Helper to pad numbers to 2 digits
    const pad = (num) => String(num).padStart(2, '0');

    // Check if all values are zero (offer expired)
    const isExpired = 
        timeLeft.days === 0 &&
        timeLeft.hours === 0 &&
        timeLeft.minutes === 0 &&
        timeLeft.seconds === 0;

    return (
        <div className=" container p-4 mx-auto border-2 border-dashed border-gray-200 mb-1 rounded-lg text-md md:text-lg lg:text-xl">
            <div className="timer-heading flex justify-evenly sm:justify-between items-center">
                <div className="div flex justify-between items-center gap-12">
                    <div className="heading font-medium text-primary hidden md:block">
                        <div className="arrow absolute w-16 z-20">
                            <img src={arrowImg} alt="arrow" className='relative top-2 -left-10 rotate-[135deg]' width="64" />
                        </div>
                        On Sale Now
                    </div>
                    <div className="timer-ends flex justify-evenly items-center gap-4 text-white">
                        <span className=' text-black hidden sm:flex'>Hurry Up!</span>
                        <span>
                            <div className="timer flex items-center gap-2">
                                <div className='w-10 p-2 bg-primary rounded-md flex justify-center items-center shadow-md'>{pad(timeLeft.days)}</div><span className='text-black'>:</span>
                                <div className='w-10 p-2 bg-primary rounded-md flex justify-center items-center shadow-md'>{pad(timeLeft.hours)}</div><span className='text-black'>:</span>
                                <div className='w-10 p-2 bg-primary rounded-md flex justify-center items-center shadow-md'>{pad(timeLeft.minutes)}</div><span className='text-black'>:</span>
                                <div className='w-10 p-2 bg-primary rounded-md flex justify-center items-center shadow-md'>{pad(timeLeft.seconds)}</div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <div className="text-center">
                {/* You can add more info here if needed */}
                {isExpired && (
                    <span className="text-red-600 font-semibold block mt-2">Offer Expired!</span>
                )}
            </div>
        </div>
    );
};

export default OfferTimer;
